import type { CampaignsType } from '@/modules/Campaigns/types'
import { axiosDZAuthInstance } from '../axios'

export const getCommunityCampaigns = async (): Promise<{ data: CampaignsType[]; total: number }> => {
  try {
    const { data } = await axiosDZAuthInstance.get<{
      items: Omit<CampaignsType, 'attachments'>[]
      totalCount: number
    }>('/dashboard/community-campaigns')

    return { data: data.items, total: data.totalCount }
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || 'Failed to fetch community campaigns'
    throw new Error(errorMessage)
  }
}

export const getCommunityCampaign = async (id: number): Promise<{ data: CampaignsType; id: number }> => {
  try {
    const { data } = await axiosDZAuthInstance.get<CampaignsType>(`/dashboard/community-campaigns/${id}`)
    return { data, id: data.id }
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || 'Failed to fetch community campaign'
    throw new Error(errorMessage)
  }
}
